import React, { useEffect, useRef } from 'react';
import './Landing.css';

const Landing = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays on mount (helps with autoplay policies)
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, []);

  const handleButtonClick = () => {
    window.location.href = 'https://lovescape.com/create-ai-girlfriend/style?userId=a85f5eda7f74d3c5c0b4b2c3db529224fc05323b4473385b30f4f71ad020bb43&p1=prelandsfw';
  };

  return (
    <div className="landing-container">
      {/* Fullscreen Video Background */}
      <video
        ref={videoRef}
        className="landing-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src="https://cdn.lovescape.com/cdn/front/videos/marketing/horse.mp4" type="video/mp4" />
      </video>

      {/* Dark Gradient Overlay */}
      <div className="landing-overlay" />

      {/* Content Layer */}
      <div className="landing-content">
        <div className="landing-text">
          <p className="landing-subtitle">
            Meet your perfect AI companion. Lovescape gives you a deeply personal, emotionally intelligent girlfriend experience — available 24/7, just for you.
          </p>
        </div>
        <button 
          className="landing-cta-button"
          onClick={handleButtonClick}
        >
          Start now
        </button>
      </div>
    </div>
  );
};

export default Landing;
